<template>
  <div>
    <div class="share-fix-body" v-show="false"  ref="posterHtml" id="posterHtml">
      <div
        class="share-box"
        :style="{ backgroundImage: 'url(' + shareBg + ')' }"
      >
        <div class="share-header">
          <h1>{{ shareInfo.title }}</h1>
          <p>创作者：{{ shareInfo.author }}</p>
        </div>
        <div class="share-info">
          <div class="img">
            <img :src="this.shareInfo.image_url" crossOrigin="anonymous" alt="" />
          </div>

          <div class="info" v-if="shareInfo.artId">
              <div class="title">收藏者</div>
              <div class="info-code">
                  <div class="info-box">
                      <div class="text">{{ shareInfo.userowner }}</div>
                      <div class="icon">
                          <div class="x" v-for="item in 8" :key="item"></div>
                      </div>
                  </div>
              </div>
              <div class="title">藏品编码</div>
              <div class="info-hax">{{ shareInfo.artId }}</div>
              <div class="title time">获得时间:{{ shareInfo.getToDate }}</div>
          </div>

          <div class="info" v-else>
            <!-- <div class="title">状态</div> -->
            <!-- <div class="title time" style="margin-top: 0.2rem">
              {{
                Number(shareInfo.status) === 1
                  ? "热卖中"
                  : Number(shareInfo.status) === 2
                  ? "已售罄"
                  : "敬请期待"
              }}
            </div> -->
          </div>
        </div>
      </div>
      <div class="share-footer" id="shareFooter">
        <div class="text" v-html="shareInfo.shareText"></div>
        <div class="qrcode-img" id="qrcodeImg"></div>
      </div>
    </div>

    <div class="share-fix" v-show="isShare">
      <div class="share-fix-img">
        <div class="share-close" @click="isShare = false"></div>
        <div class="img">
          <img :src="posterImg" style="width: 100%" alt="" />
        </div>
      </div>
      <div class="share-nav">
        <div class="item">
          <a :href="posterImg" :download="shareInfo.title">
            <div class="img">
              <img
                src="../../assets/images/user/treasure/download.png"
                alt=""
              />
            </div>
            <div class="text">保存到相册</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { Toast } from "vant";
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";

export default {
  name: "sub-header",
  data() {
    return {
      shareBg: require("../../assets/images/user/treasure/share-bg.png"), // 背景图
      posterImg: "",
      isShare: false,
    };
  },

  props: {
    shareInfo: {
      type: Object,
    },
  },
  methods: {
    createQrcode(text) {
      // 生成二维码
      const qrcodeImgEl = document.getElementById("qrcodeImg");
      qrcodeImgEl.innerHTML = "";
      let qrcode = new QRCode(qrcodeImgEl, {
        width: 256,
        height: 256,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
      qrcode.makeCode(text);
    },
    async createPoster() {
      // 生成海报
      let vm = this;
      let domObj = document.getElementById("posterHtml");
      if (vm.posterImg) {
        vm.isShare = true;
        return false;
      }
      
      let toastLoading = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "正在加载...",
      });

      let imgArr = [this.shareInfo.image_url, this.shareBg];

      this.$utils.loadImageEnd(imgArr, () => {
        html2canvas(domObj, {
          useCORS: true,
          allowTaint: false, // 允许跨原始图像污染画布
          logging: false,
          letterRendering: true,
          onclone(doc) {
            doc.querySelector("#shareFooter").style.display = "block";
            doc.querySelector("#posterHtml").style.display = "block";
          },
        }).then(function (canvas) {
          Toast.clear();
          // 在微信里,可长按保存或转发
          vm.posterImg = canvas.toDataURL("image/png");
          vm.isShare = true;
        });
      });
    },
  },
  mounted() {



    // let url = window.location.href;
    // this.createQrcode(url);
  },
};
</script>


<style lang="scss" scoped>
.share-fix {
  position: fixed;
  z-index: 11;
  top: 0;
  width: 100%;
  left: 0;
  height: 100%;
  box-sizing: border-box;
  background: #333333;
  
  .share-fix-body {
    background: rgba($color: #000000, $alpha: 0.5);
    height: 100%;
    
    // height:100vh;
  }
  .share-close {
    position: fixed;
    left: 0.16rem;
    top: 0.3rem;
    width: 0.31rem;
    height: 0.36rem;
    background: url(../../assets/images/common/back.png) no-repeat center;
    background-size: 100%;
  }
  .share-fix-img {
    position: relative;
    height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling : touch;
    .img {
      padding-bottom: 1.8rem;
      img {
        width: 100%;
      }
    }
  }
}

.share-fix-body {
  position: relative;
  padding: 0.5rem 0;
  background: rgba($color: #000000, $alpha: 0.8);
  height:100vh;
  .share-box {
    margin: 0 auto 0.5rem;
    width: 6.87rem;
    height: 9.88rem;
    box-sizing: border-box;
    background-position: left top;
    background-size: 100% auto;
    position: relative;

    .share-header {
      padding: 0.42rem 0.32rem 0;
      line-height: 1.2;
      height: 1.53rem;
      box-sizing: border-box;
      h1 {
        font-size: 0.36rem;
        color: #ad6f16;
      }
      p {
        color: #865302;
        font-size: 0.26rem;
        margin-top: 0.1rem;
      }
    }

    .share-info {
      height: 8.15rem;
      box-sizing: border-box;
      // background: url("../../assets/images/user/treasure/img-b-xu.png")no-repeat bottom center;
      background: url("../../assets/images/user/treasure/img-b-xu.png")
        no-repeat center 3.85rem;
      background-size: 74% auto;
      padding-top: 0.65rem;
      position: relative;
      z-index: 9;

      .img {
        text-align: center;
        width: 93%;
        height: 3.9546rem;
        margin: 0 auto;
        img {
          height: 100%;
          max-width: 100%;
        }
      }
      .info {
        padding: 0.34rem 0.35rem;
        color: #e1e1e1;
        font-size: 0.24rem;
        .title {
          line-height: 1.2;
        }

        .info-code {
          // width: 4.28rem;
          display: inline-block;
          position: relative;
          margin: 0.2rem 0 0.3rem;
          padding: 0.1rem 0 0.1rem;
          box-sizing: border-box;
          margin-left: -0.1rem;

          &::before,
          &::after {
            content: "";
            position: absolute;
            left: 0;
            width: 100%;
            height: 0.2rem;
            background: url("../../assets/images/user/treasure/code-border-fix.png")
              no-repeat;
            background-size: 100% auto;
          }

          &::before {
            top: 0;
            background-position: left top;
          }
          &::after {
            bottom: 0;
            background-position: left bottom;
          }
          .info-box {
            background: url("../../assets/images/user/treasure/code-border-fix-1.png")
              repeat-y;
            background-size: 100% auto;
            padding: 0.1rem 0.1rem;

            .text {
              text-align: left;
              font-size: 0.3rem;
              color: #fff;
              line-height: 1.2;
              white-space: nowrap;
            }
            .icon {
              display: flex;
              align-items: center;
              
              justify-content: space-between;
              margin: 0 0.1rem;
              margin-top: 0.04rem;
              .x {
                width: 0.19rem;
                height: 0.18rem;
                background: url("../../assets/images/user/treasure/x.png")
                  no-repeat;
                background-size: 100%;
              }
            }
          }
        }

        .info-hax {
          font-size: 0.24rem;
          color: #fff;
          line-height: 1.2;
          box-sizing: border-box;
          word-break: break-all;
          margin-top: 0.2rem;
          height: 0.288rem;
        }
        .time {
          margin-top: 0.2rem;
        }
      }
    }
  }

  .share-footer {
    // display: none;
    overflow: hidden;
    width: 6.54rem;
    margin: 0 auto 0.5rem;
    color: #ffffff;
    font-size: 0.3rem;
    line-height: 1.6;
    position: relative;
    .text {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    .qrcode-img {
      float: right;
      width: 1.7rem;
      height: 1.7rem;
      padding: 0.1rem;
      background: #ffffff;
      box-sizing: border-box;
    }
  }
}

.share-nav {
  position: fixed;
  left: 0;
  width: 100%;
  bottom: 0;
  background: #000000;
  z-index: 9;
  height: 2.1rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.2;

  // display: none;

  .item {
    text-align: center;
    img {
      width: 0.83rem;
      height: 0.83rem;
    }
    .text {
      font-size: 0.24rem;
      color: #c1c1c1;
      margin-top: 0.14rem;
    }
    &:active {
      opacity: .8;
    }
  }
}
</style>


<style lang="scss">
.qrcode-img {
  canvas {
    width: 100% !important;
    height: 100% !important;
  }
  img {
    width: 100% !important;
    height: 100% !important;
  }
}
</style>
